import { DEFAULT_FIXED_CAMERA_ANGLE, MIN_CAMERA_ANGLE, MAX_CAMERA_ANGLE } from '../../../renderer/src/camera-angle';
import { CompactRangeControl } from './CompactRangeControl';

interface Properties { minimum?: number; maximum?: number; value: number | null; onChange: (value: number | null) => void }

export function CameraAngleControl({ value, onChange, minimum = MIN_CAMERA_ANGLE, maximum = MAX_CAMERA_ANGLE }: Properties) {
  return <>
    <label className="studio-select-row"><span className="studio-select-caption">Camera angle <span className="studio-pro-badge">PRO</span></span><select aria-label="Camera angle mode" value={value === null ? 'automatic' : 'fixed'}
      onChange={event => onChange(event.target.value === 'automatic' ? null : DEFAULT_FIXED_CAMERA_ANGLE)}>
      <option value="automatic">Automatic</option><option value="fixed">Fixed angle</option>
    </select></label>
    {value !== null && <CompactRangeControl label="Camera angle" value={value} min={minimum} max={maximum} step={.1}
      unit="°" valueText={`${value} degrees from top-down`} help={`0° top-down · ${maximum}° oblique`} onChange={onChange} />}
  </>;
}
